import { MutableRefObject, useEffect, useState } from 'react';

export default function useOnScreen<T extends HTMLOrSVGElement>(
  ref?: MutableRefObject<T | null>,
  rootMargin = '0px',
): boolean {
  // State and setter for storing whether element is visible
  let initialState = false;
  if (!ref || process.env.NODE_ENV === 'test') {
    initialState = true;
  }
  const [isIntersecting, setIntersecting] = useState<boolean>(initialState);
  useEffect(() => {
    if (!ref || process.env.NODE_ENV === 'test') {
      return;
    }
    const el = ref.current;
    const observer = new IntersectionObserver(
      (entries) => {
        // Update our state when observer callback fires
        const found = entries.find((entry) => entry.isIntersecting);
        setIntersecting(!!found);
      },
      {
        rootMargin,
      },
    );
    if (el instanceof Element) {
      observer.observe(el);
    }
    return () => {
      if (el instanceof Element) {
        observer.unobserve(el);
      }
    };
  }, [ref, rootMargin]); // Empty array ensures that effect is only run on mount and unmount
  return isIntersecting;
}
